import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { CurrentEmpresa } from '@rpe/registro-personas-empresas-lib';
import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';

export const entityCurrentEmpresaAdapter: EntityAdapter<CurrentEmpresa> =
  createEntityAdapter<CurrentEmpresa>({
    selectId: (model) => model.id,
    sortComparer: (a: CurrentEmpresa, b: CurrentEmpresa): number => -1
  });

export interface EntityCurrentEmpresaState extends EntityState<CurrentEmpresa> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityCurrentEmpresaState =
  entityCurrentEmpresaAdapter.getInitialState({
    isLoading: false,
    error: null
  });
